import { useAtom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

const showDescriptionColumnAtom = atomWithStorage<boolean>('bookkeeping-show-description-column', false);

export const useShowDescriptionColumn = () => useAtom(showDescriptionColumnAtom);

const showCompetencePeriodColumnAtom = atomWithStorage<boolean>('bookkeeping-show-competence-period-column', false);

export const useShowCompetencePeriodColumn = () => useAtom(showCompetencePeriodColumnAtom);

const showAdjustmentColumnAtom = atomWithStorage<boolean>('bookkeeping-show-adjustment-column', false);

export const useShowAdjustmentColumn = () => useAtom(showAdjustmentColumnAtom);
